import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslatePipe } from '@ngx-translate/core';
import { MainLayoutComponent } from '../main-layout/main-layout.component';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
  imports: [MatIconModule, MainLayoutComponent, TranslatePipe],
})
export class PageNotFoundComponent {}
